// CB:BEGIN settings-section-component
import React from 'react';

interface SettingsSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function SettingsSection({ title, description, children }: SettingsSectionProps) {
  return (
    <div style={{ marginBottom: '32px' }}>
      <h3 style={{ fontSize: '14px', fontWeight: '600', marginBottom: description ? '8px' : '16px', color: '#1e293b' }}>
        {title}
      </h3>
      {description && (
        <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px', lineHeight: '1.5' }}>
          {description}
        </p>
      )}
      {children}
    </div>
  );
}
// CB:END settings-section-component

